/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const AddGiftCard = dynamic(() => import('./AddGiftCard').then(mod => mod.AddGiftCard));

export const AddGiftCardConfig = {
  emptyLabel: 'addGiftCard',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/addgiftcard`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AddGiftCardEditable = (props: any) => (
  <EditableComponent config={AddGiftCardConfig} {...props}>
    <AddGiftCard {...props} />
  </EditableComponent>
);
